import './bootstrap'
import Vue from 'vue'
import VueMq from 'vue-mq'
import 'jquery-validation'

Vue.config.ignoredElements = ['iframe', 'date', 'time']
Vue.config.productionTip   = false

Vue.use(VueMq, {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
})

new Vue({
  mounted () {
    $('#login-form').validate({
      ignore: [],
      highlight: function (element, errorClass, validClass) {
        $(element).addClass('is-invalid')
      },
      unhighlight: function (element, errorClass, validClass) {
        $(element).removeClass('is-invalid')
      },
      errorPlacement: function (label, element) {
        if (element.hasClass('search-select-multiple-keywords') ||
          element.hasClass('search-select-multiple-institutions')) {
          label.insertAfter(element.siblings('span.select2'))
        }
        else {
          label.insertAfter(element)
        }
        
        label.addClass('invalid-feedback text-left')
      },
      rules: {
        email: {
          required: true,
          email: true,
        },
        password: {
          required: true,
        },
      },
      messages: {
        email: {
          required: 'El correo es requerido para iniciar sesión.',
          email: 'El formato de correo es incorrecto.',
        },
        password: {
          required: 'La contraseña es requerida.',
        },
      },
      submitHandler (form) {
        $('#login-form button[type="submit"] .spinner-border').
          removeClass('d-none').
          addClass('d-inline-block')
        
        $('#login-form button[type="submit"]').prop('disabled', true)
        
        form.submit()
      },
    })
  },
}).$mount('.app')
